import ContentHandler from './ContentHandler';

export default ContentHandler;
